import React from 'react'
import { useHistory } from 'react-router-dom'

import { AcornsIcon } from '@acorns/icons'
import { useRemoteStrings } from '@acorns/web-utils'

import BrandsSvg from 'assets/images/brands.svg'
import {
  Product,
  SelfDirectedPortfolio,
  SelfDirectedPortfolioStatus,
  useTierGroupForUserQuery,
} from 'generated/types'
import { ProductKey } from 'generated/types'
import { routes } from 'router/routes'
import { PORTFOLIO_WIDGET_PASSIONS_LAUNCH } from 'utils/testing/testIDs'

import {
  BrandsImg,
  CustomizeHeaderText,
  CustomizeLearnMoreButton,
  CustomizePortfolioItem,
  DetailsContainer,
  LearnMoreContainer,
  LearnMoreSpan,
  MobileImg,
  StyledArrowRight,
} from './styled-components'

type Props = {
  investmentProduct: ProductKey
  products: Product[]
  selfDirectedPortfolio?: SelfDirectedPortfolio
  screen?: string
}

export const CustomPortfolioCard = ({
  investmentProduct,
  screen,
  selfDirectedPortfolio,
}: Props) => {
  const history = useHistory()

  const isInvestProduct = investmentProduct === ProductKey.Invest
  const { getRemoteString } = useRemoteStrings()

  const { data: tierGroup } = useTierGroupForUserQuery({
    fetchPolicy: 'cache-and-network',
  })
  const tierGroupIncludesSelfDirected =
    tierGroup?.tierGroupForUser?.tierOptions?.some((tierOption) =>
      tierOption?.tier?.products?.find(
        (product) => product.key === ProductKey.SelfDirectedInvest,
      ),
    )

  const isDisplayed =
    (!selfDirectedPortfolio?.id ||
      selfDirectedPortfolio?.status === SelfDirectedPortfolioStatus.Closed) &&
    isInvestProduct &&
    tierGroupIncludesSelfDirected

  const handleContainerClick = (e: any) => {
    e.stopPropagation()
    history.push(routes.customPortfolio.lander)
  }

  return (
    <>
      {isDisplayed ? (
        <CustomizePortfolioItem
          screen={screen}
          data-testid={PORTFOLIO_WIDGET_PASSIONS_LAUNCH}
          onClick={handleContainerClick}
        >
          <DetailsContainer>
            <CustomizeHeaderText>
              {getRemoteString({ key: 'passions.customize.header.text' })}
            </CustomizeHeaderText>
            <LearnMoreContainer>
              <CustomizeLearnMoreButton>
                <LearnMoreSpan>
                  {getRemoteString({ key: 'passions.customize.cta.text' })}
                  <StyledArrowRight
                    icon={AcornsIcon.Icon.UtilityArrowRight}
                    width="20px"
                    height="20px"
                  />
                </LearnMoreSpan>
              </CustomizeLearnMoreButton>
              <MobileImg src={BrandsSvg} />
            </LearnMoreContainer>
          </DetailsContainer>
          <BrandsImg screen={screen} src={BrandsSvg} />
        </CustomizePortfolioItem>
      ) : null}
    </>
  )
}
